import { TGlobalStores } from '.';
import { IAreaDimension, ILinearDimension } from '../data/dimension/dimension';
import { EEntityType } from '../types';
import { BaseListStore } from './base/baseListStore';

export class DimensionStore {
  private _gs: TGlobalStores;

  private _areaDimensionMap: BaseListStore<IAreaDimension>;
  private _linearDimensionMap: BaseListStore<ILinearDimension>;
  constructor(gs: TGlobalStores) {
    this._gs = gs;
    this._areaDimensionMap = new BaseListStore(gs, { dataType: EEntityType.AreaDimension });
    this._linearDimensionMap = new BaseListStore(gs, { dataType: EEntityType.LinearDimension });
  }

  // ========== 面积标注 ========== //
  public addAreaDim(data: IAreaDimension) {
    this._areaDimensionMap.add(data);
  }

  public removeAreaDim(id: string) {
    this._areaDimensionMap.remove(id);
  }

  public updateAreaDim(data: Partial<IAreaDimension>) {
    if (data.id) {
      this._areaDimensionMap.update(data.id, data);
    }
  }

  public getAreaDimList() {
    return this._areaDimensionMap.getList();
  }

  public getAreaDim(id: string) {
    return this._areaDimensionMap.get(id);
  }

  // ========== 尺寸标注 =========== //
  public addLinearDim(data: ILinearDimension) {
    this._linearDimensionMap.add(data);
  }

  public removeLinearDim(id: string) {
    this._linearDimensionMap.remove(id);
  }

  public updateLinearDim(id: string, data: Partial<ILinearDimension>) {
    if (id) {
      this._linearDimensionMap.update(id, data);
    }
  }

  public getLinearDimList() {
    return this._linearDimensionMap.getList();
  }

  public getLinearDim(id: string) {
    return this._linearDimensionMap.get(id);
  }

  public clearAll() {
    this._areaDimensionMap.clear();
    this._linearDimensionMap.clear();
  }

  public coverDatas({
    areaDimensionDatas,
    linearDimensionDatas
  }: {
    areaDimensionDatas: IAreaDimension[];
    linearDimensionDatas: ILinearDimension[];
  }) {
    this.clearAll();

    areaDimensionDatas.forEach((areaDimension) => {
      this.addAreaDim(areaDimension);
    });

    linearDimensionDatas.forEach((linearDimension) => {
      this.addLinearDim(linearDimension);
    });
  }
}
